import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Heart } from "lucide-react";
import { LEGAL_DOCS, LEGAL_CONTENT } from "@/data/legal";
import { useLang } from "@/context/LanguageContext";

export const LegalPage = () => {
    const { doc } = useParams();
    const { lang } = useLang();
    const entry = LEGAL_DOCS.find((d) => d.slug === doc) || LEGAL_DOCS[0];
    const content = LEGAL_CONTENT[entry.key][lang];

    return (
        <main
            data-testid="legal-page"
            className="min-h-screen bg-[#FAF6F1] px-4 py-10 sm:py-14"
        >
            <div className="max-w-3xl mx-auto">
                <Link
                    to="/"
                    data-testid="legal-back-home"
                    className="inline-flex items-center gap-2 text-sm font-semibold text-bordeaux hover:opacity-80 transition-opacity"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Amor Sin Aviso
                </Link>
                <h1 className="font-serif text-3xl sm:text-4xl text-stone-900 mt-6">
                    {content.title}
                </h1>
                <div className="mt-8 space-y-7">
                    {content.body.map(([h, p]) => (
                        <section key={h}>
                            <h2 className="text-sm font-bold text-bordeaux uppercase tracking-wide">
                                {h}
                            </h2>
                            <p className="mt-2 text-[15px] leading-relaxed text-stone-700">
                                {p}
                            </p>
                        </section>
                    ))}
                </div>
                <p className="mt-10 flex items-center gap-2 text-[11px] text-stone-400">
                    <Heart className="h-3 w-3 text-bordeaux" />
                    Amor Sin Aviso · Marbella
                </p>
            </div>
        </main>
    );
};